<div class="featured-card"
  [ngStyle]="{'background': 'url(' + content.image + ')', 'background-size': 'cover'}">
  <div class="featured-card-content">
    <div class="content-title">{{ content.title }}</div>
    <div class="content-subtitle">{{ content.subtitle }}</div>
  </div>
</div>